import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { BCPLockKeyhole } from "../../../components/icons/bcp/BCPIcons";
import Login from "./Login";

export default function LoginRedirect() {
  const theme = useTheme();
  const [showLogin, setShowLogin] = useState(false);

  if (!showLogin) {
    return (
      <Box width="100%">
        <Container maxWidth="lg" sx={{ pt: 2, pb: 2 }}>
          <Grid
            container
            sx={{
              p: 2,
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            spacing={1}
          >
            <Grid item xs={12}>
              <Typography variant="h3" sx={{ pt: 2 }}>
                You must be logged in to view this page
              </Typography>
            </Grid>

            <Grid item xs={12} SX={{ pt: 1, pb: 1 }}>
              <BCPLockKeyhole
                sx={{
                  fontSize: "50px",
                  width: "50px",
                  color: theme?.palette?.text?.disabled,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" paragraph>
                You may log in by clicking the button below or you can return{" "}
                <Link href="/">home.</Link>
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Button
                variant="contained"
                fullWidth
                onClick={() => {
                  setShowLogin(true);
                }}
              >
                Sign in
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }

  return <Login />;
}
